import React, { Component } from "react";
import Payroll from "../../../components/Payroll/Payroll";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PayrollForm
Description : Componente que invoca al componente Payroll, para la configuración de la nómina.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Payroll
================================================================================ */
class PayrollForm extends Component{
    render(){
        return(
            <Payroll/>  
        )   
    }
}

export default PayrollForm;